// eslint-disable-next-line import/no-default-export -- deprecated usage
export { default, BEFORE_UNLOAD_UNSAVED_MESSAGE } from "./use-before-unload";
